import { SVGProps } from 'react';

const SvgPills = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 576 512"
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M112 80c35.3 0 64 28.7 64 64v112H48V144c0-35.3 28.7-64 64-64zM0 144v224c0 61.9 50.1 112 112 112s112-50.1 112-112V144c0-61.9-50.1-112-112-112S0 82.1 0 144zm416 288c-61.9 0-112-50.1-112-112 0-22.2 6.5-43 17.7-60.4l154.7 154.7C459 425.5 438.2 432 416 432zm-60.4-206.3C373 214.5 393.8 208 416 208c61.9 0 112 50.1 112 112 0 22.2-6.5 43-17.7 60.4L355.6 225.7zM416 480a160 160 0 1 0 0-320 160 160 0 1 0 0 320z" />
  </svg>
);
export default SvgPills;
